import React from 'react';
import styled from 'styled-components';
import { FormationImageMode } from '../../../shared/enum/EnumRepository';
import { PaperBlurFitBtn } from '../../../shared/component/headless/button/BtnBody';

interface FormationSlotControlsProps {
  imageMode: FormationImageMode;
  onImageModeChange: (imageMode: FormationImageMode) => void;
}

const FormationSlotControls: React.FC<FormationSlotControlsProps> = ({
  imageMode,
  onImageModeChange,
}) => {
  const nextImageMode = imageMode === FormationImageMode.FIT
    ? FormationImageMode.FILL
    : FormationImageMode.FIT;

  return (
    <ToggleButton
      type="button"
      title={`Switch to ${nextImageMode}`}
      aria-label={`Current image mode: ${imageMode}. Switch to ${nextImageMode}`}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        onImageModeChange(nextImageMode);
      }}
    >
      {imageMode}
    </ToggleButton>
  );
};

const ToggleButton = styled(PaperBlurFitBtn)`
  position: absolute;
  top: 4px;
  right: 4px;
  padding: 4px 6px;
  border: 0;
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Footer_02}
  z-index: 1;
  cursor: pointer;
`;

export default FormationSlotControls;
